import React from "react";

function ActionButton({ children, onClick, danger, primary, disabled }) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={[
        "pointer-events-auto px-3 py-1.5 rounded border text-xs whitespace-nowrap shadow-sm disabled:opacity-40",
        primary
          ? "bg-blue-600 text-white border-blue-600 hover:bg-blue-700"
          : danger
          ? "bg-white text-red-600 border-red-200 hover:bg-red-50"
          : "bg-white text-slate-700 border-slate-200 hover:bg-slate-50",
      ].join(" ")}
    >
      {children}
    </button>
  );
}

export default function SelectionActionBar({
  visible,
  selectedLabel,

  onQuickAdd,
  onInspect,
  onGridEdit,
  onPresent,
  onOpenSource,
  onDelete,
  onClearSelection,

  canRemove,
}) {
  if (!visible) return null;

  return (
    <div className="absolute left-1/2 bottom-4 z-30 -translate-x-1/2 pointer-events-none">
      <div className="rounded-xl border bg-white/95 shadow-lg px-3 py-2 flex items-center gap-2 backdrop-blur">
        <div className="min-w-[160px] max-w-[260px] pr-2 border-r">
          <div className="text-[10px] uppercase tracking-wide text-slate-400 font-semibold">
            Selected
          </div>
          <div className="text-xs font-medium text-slate-700 truncate">
            {selectedLabel || "Element"}
          </div>
        </div>

        <div className="flex items-center gap-1">
          <ActionButton onClick={() => onQuickAdd?.("left")}>
            Add Left
          </ActionButton>

          <ActionButton onClick={() => onQuickAdd?.("right")}>
            Add Right
          </ActionButton>

          <ActionButton onClick={() => onQuickAdd?.("front")}>
            Add Front
          </ActionButton>

          <ActionButton onClick={() => onQuickAdd?.("back")}>
            Add Back
          </ActionButton>
        </div>

        <div className="w-px h-6 bg-slate-200" />

        <div className="flex items-center gap-1">
          <ActionButton onClick={onOpenSource}>
  Open Source
</ActionButton>

          <ActionButton onClick={onInspect} primary>
            Inspect
          </ActionButton>

          <ActionButton onClick={onGridEdit}>
            Grid Edit
          </ActionButton>

          <ActionButton onClick={onPresent}>
            Present
          </ActionButton>
        </div>

        <div className="w-px h-6 bg-slate-200" />

        <div className="flex items-center gap-1">
          <ActionButton onClick={onClearSelection}>
            Esc
          </ActionButton>

          <ActionButton onClick={onDelete} disabled={!canRemove} danger>
            Delete
          </ActionButton>
        </div>
      </div>
    </div>
  );
}